var _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJaCalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2252_1959",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 44,
    height: 44
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.0003,
    cy: 23.9998,
    r: 21.2571,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2252_1959)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.0287,
    cy: 27.7714,
    rx: 5.48571,
    ry: 5.48571,
    fill: "#EDF4FC"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.41178,
    height: 3.52945,
    rx: 0.705891,
    transform: "matrix(-0.849193 0.528083 0.548023 0.836464 31.9014 31.8179)",
    fill: "#5096E8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.395,
    height: 3.57092,
    rx: 0.697499,
    transform: "matrix(-0.215524 0.976499 0.976499 0.215524 31.707 28.9434)",
    fill: "#5096E8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.41178,
    height: 3.52945,
    rx: 0.705891,
    transform: "matrix(-0.548015 -0.836469 0.849187 -0.528092 32.8457 27.8623)",
    fill: "#5096E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8789 15.7748C33.7385 15.508 33.4098 15.4049 33.1432 15.5462C33.0627 15.5871 31.1432 16.5324 28.5745 14.8234L28.1715 14.5558L27.8572 14.9196C27.8053 14.9797 27.5619 15.3005 27.896 15.6813C27.9213 15.7107 27.9588 15.7516 28.0044 15.8028C28.2111 16.0335 28.6407 16.5126 28.8718 16.8519C28.9509 16.9679 29.1759 17.5863 29.1773 18.8647C29.178 19.9458 29.0123 21.8043 28.2192 24.5167C28.0467 25.1071 26.8384 29.9033 26.6836 31.5223C26.52 33.23 27.2544 36.7757 27.2857 36.9259L27.6199 38.0534C27.7167 38.3783 27.7583 38.7032 27.744 39.0172C27.7215 39.5004 27.5571 39.8499 27.2421 40.0847C26.4218 40.6962 24.7525 40.4594 24.179 40.3167L24.1484 40.3099C22.6993 40.0341 21.7788 40.0976 20.2534 40.2027L20.1791 40.2082L15.084 40.7351C14.2221 40.7658 13.8927 40.4143 13.7189 40.1454C13.5702 39.9147 13.5163 39.8308 13.4611 39.585C13.6329 39.4397 14.0734 39.1858 14.6278 39.1052C15.7584 38.94 16.3312 38.6602 17.7154 37.9852C17.9363 37.8773 18.1791 37.7593 18.4505 37.6282C21.4638 36.1765 22.9776 34.8483 22.891 31.6185V31.6021L22.4491 26.5036L21.5388 14.8432C21.4181 13.4556 21.5013 12.5799 21.817 11.9144C22.1204 11.2762 22.6707 10.7507 23.7154 10.1016C24.7682 9.51462 27.7508 8.17208 31.5857 7.24861C31.8789 7.17831 32.059 6.88345 31.9887 6.58997C31.9178 6.29648 31.6232 6.11629 31.3307 6.18659C26.3652 7.38239 23.3008 9.0819 23.1726 9.15425L23.1521 9.16653C20.7948 10.6272 20.1893 11.9219 20.4518 14.9333L21.3622 26.593L21.8006 31.6635C21.8627 34.0968 21.0376 35.1697 17.9773 36.644C17.7045 36.775 17.4597 36.8945 17.2374 37.003C15.8873 37.6617 15.4324 37.8828 14.4696 38.0241C13.6595 38.1428 12.8344 38.5599 12.5078 39.0158C12.3346 39.2574 12.3285 39.4724 12.3537 39.6103C12.4546 40.1597 12.5569 40.3556 12.8024 40.7365C13.2695 41.4613 13.9998 41.8285 14.9749 41.8285C15.0315 41.8285 15.0881 41.8272 15.146 41.8251H15.1624L20.263 41.2962L20.3284 41.2914C21.8095 41.189 22.6284 41.133 23.9308 41.3794C24.1743 41.4381 26.5329 41.9732 27.8919 40.9617C28.4702 40.5317 28.7961 39.8765 28.8343 39.0677C28.8548 38.6302 28.7982 38.1831 28.6659 37.7402L28.3502 36.6802C28.2888 36.3805 27.6294 33.1057 27.7706 31.626C27.911 30.1599 29.0587 25.5378 29.2673 24.8232C30.5513 20.4318 30.3686 17.8142 29.9874 16.6915C32.0965 17.3085 33.5714 16.555 33.6505 16.5126C33.9171 16.372 34.0208 16.0403 33.8796 15.7741L33.8789 15.7748Z",
    fill: "#536479"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJaCalf);
export default __webpack_public_path__ + "static/media/ja_calf.04ee8587cbb9e1d7ffa857593e6b1391.svg";
export { ForwardRef as ReactComponent };